import { Droplets } from "lucide-react";

const ITEMS = [
  "A Home Essential With A Taste of Design",
  "Seamless Aluminum & Copper Gutters",
  "Heavy-Duty Downspouts",
  "Micro-Mesh Gutter Guards",
  "Basement Waterproofing",
  "French Drainage Systems",
  "Foundation Crack Sealing",
];

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-white/10 bg-ink2 py-5"
    data-testid="trade-marquee"
  >
    <div className="flex w-max animate-marquee items-center gap-10">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-10 whitespace-nowrap font-display text-xl font-semibold uppercase tracking-wider text-slate-500"
        >
          {item}
          <Droplets className="h-4 w-4 text-orange-500" />
        </span>
      ))}
    </div>
  </div>
);
